import { DataProvider } from "@refinedev/core";
import { IDataContextProvider } from "@refinedev/core/dist/contexts/data/IDataContext";
import { AxiosInstance } from "axios";

import axAPI from "../../../api/axios-instance";

/**
 * 11615 «ФНЛ ТВ»: один провайдер на все ресурсы раздела.
 * Ресурс = путь в /api/v1/cms/tv. Списки, кроме видео, приходят массивом без пагинации.
 */
const BASE = "cms/tv";

const RESOURCE_PATH: Record<string, string> = {
  "tv-videos": "videos",
  "tv-shows": "shows",
  "tv-collections": "collections",
  "tv-showcase": "showcase",
  "tv-leagues": "leagues",
  "tv-matches": "matches",
  "tv-settings": "settings",
};

const path = (resource: string) => {
  const p = RESOURCE_PATH[resource];
  if (!p) throw new Error(`Неизвестный ресурс ТВ: ${resource}`);
  return `${BASE}/${p}`;
};

/** Фильтры useTable → параметры запроса (пустые не отправляем). */
const toParams = (filters?: { field?: string; value?: unknown }[]) =>
  Object.fromEntries(
    (filters ?? [])
      .filter(
        (f) =>
          f.field && f.value !== undefined && f.value !== null && f.value !== ""
      )
      .map((f) => [f.field as string, f.value])
  );

export const tvDataProvider = (
  apiUrl: string,
  httpClient: AxiosInstance = axAPI
): DataProvider =>
  <IDataContextProvider>{
    getApiUrl: () => apiUrl,
    getList: async ({ resource, pagination, filters }) => {
      if (resource === "tv-videos") {
        const pageSize = pagination?.pageSize ?? 20;
        const current = pagination?.current ?? 1;
        const { data } = await httpClient.get(path(resource), {
          params: {
            ...toParams(filters as { field?: string; value?: unknown }[]),
            limit: pageSize,
            offset: pageSize * (current - 1),
          },
        });
        return { data: data.items, total: data.total };
      }
      const { data } = await httpClient.get(path(resource), {
        params: toParams(filters as { field?: string; value?: unknown }[]),
      });
      return { data, total: data.length };
    },
    getOne: async ({ resource, id }) => {
      const url =
        resource === "tv-settings" ? path(resource) : `${path(resource)}/${id}`;
      const { data } = await httpClient.get(url);
      return { data };
    },
    create: async ({ resource, variables }) => {
      const { data } = await httpClient.post(path(resource), variables);
      return { data };
    },
    update: async ({ resource, id, variables }) => {
      const url =
        resource === "tv-settings" ? path(resource) : `${path(resource)}/${id}`;
      const { data } = await httpClient.put(url, variables);
      return { data };
    },
    deleteOne: async ({ resource, id }) => {
      await httpClient.delete(`${path(resource)}/${id}`);
      return { data: { id } };
    },
  };
